<nwm-menu />
<div class="content">
  <button aria-label="Expand Sidebar" class="expand-btn d-print-none" (click)="isCollapse = !isCollapse"  [ngClass]="{'visually-hidden': !isCollapse}"><i class="fa fa-angle-right"></i></button>
  @if (sideMenuItems.length>0) {
    <div class="row main no-gutters welcome">
      <div class="col-xxl-10 offset-xxl-1">
        <a class="anchor" id="summary" aria-hidden="true"></a>
        <div class="row">
          <div class="side-menu d-print-none" [ngClass]="{'col-lg-2': !isCollapse ,'visually-hidden': isCollapse}">
            <div class="sticky">
              <button aria-label="Collapse Sidebar" class="collapse-btn" (click)="isCollapse = !isCollapse"><i class="fa fa-angle-left"></i></button>
              <side-menu class="full-height"
                menuTitle="Select Account"
                defaultTitle = "Portfolio Summary"
                [isOverViewPage] = true
                [items]="sideMenuItems"
                [active]="plan"
                [container]="'#sideMenuContainer'"
                (menuChange)="changeAccount($event)"
                (opened)="changeGroup($event)"
                (dateChange)="onValuationDateChange()" />
              </div>
            </div>
            <div class="col-lg-10 w-print-100 welcome-main-content" [ngClass]="{'col-lg-10': !isCollapse ,'col-lg-12': isCollapse}" >
              <portfolio-details [plan]="planData" isPortfolioPage="true" isOverViewPage="true" #PDt />
              <div class="mb-5 pb-2">
                <disclaimer [fxRate]="PDt.portfolio ? PDt.portfolio.fxRate.UsdToCadRate.toString() : ''" />
              </div>
            </div>
          </div>
        </div>
      </div>
    }
  </div>
